import { render, staticRenderFns } from "./statGoodsLabels.vue?vue&type=template&id=03a25f7c&scoped=true&"
import script from "./statGoodsLabels.vue?vue&type=script&lang=js&"
export * from "./statGoodsLabels.vue?vue&type=script&lang=js&"
import style0 from "./statGoodsLabels.vue?vue&type=style&index=0&id=03a25f7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a25f7c",
  null
  
)

component.options.__file = "statGoodsLabels.vue"
export default component.exports